import type { PageContext } from "../client.js";

export function pageContext(nowMs = Date.now()): PageContext {
  return { url: location.href, referrer: document.referrer, nowMs };
}

export function pageProps(): Record<string, unknown> {
  return { title: document.title, path: location.pathname };
}
